import { CopySimple } from '@phosphor-icons/react';
import { withMagneticIcon } from '../withMagneticIcon.js';

const Icon = withMagneticIcon(CopySimple);
Icon.displayName = "CopySimple";

export { Icon as CopySimple };
//# sourceMappingURL=CopySimple.js.map
